(() => {
  'use strict';
  const section = document.querySelector('#tkb-single-bag');
  if (!section || section.dataset.singleReady) return;
  const find = selector => section.querySelector(selector);
  let catalog;
  try { catalog = JSON.parse(find('[data-single-catalog]').textContent); } catch (_) { return; }
  if (!Array.isArray(catalog.bags) || !catalog.bags.some(v => v.id && v.price > 0)) return;
  section.dataset.singleReady = 'true';
  const details = find('[data-single-details]'), offer = find('[data-single-offer]');
  const buy = find('[data-single-buy]'), yes = find('[data-single-yes]'), no = find('[data-single-no]');
  const close = find('[data-single-close]'), status = find('[data-single-status]');
  const fallback = find('[data-single-fallback]'), cartLink = find('[data-single-cart-link]');
  const commerce = find('.tb-single__commerce'), mobile = matchMedia('(max-width: 800px)');
  const offerStatus = find('[data-offer-status]'), offerCartLink = find('[data-offer-cart-link]');
  const message = text => { status.textContent = text; offerStatus.textContent = text; };
  const showCartLink = visible => { cartLink.hidden = !visible; offerCartLink.hidden = !visible; };
  const reference = variant => Math.max(Number(variant.compare || 0), variant.price);
  const money = value => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value / 100);
  const root = window.Shopify?.routes?.root || '/';
  let bagColor = (catalog.bags.find(v => v.color === 'Preto' && v.available) || catalog.bags.find(v => v.available) || catalog.bags[0]).color;
  let bottleColor = (catalog.combos.find(v => v.bag === bagColor && v.available)?.bottle || 'Preto');
  let busy = false, settled = false, uncertain = false;
  const bag = () => catalog.bags.find(v => v.color === bagColor);
  const bottle = () => catalog.bottles.find(v => v.color === bottleColor);
  const combo = () => catalog.combos.find(v => v.bag === bagColor && v.bottle === bottleColor);
  const valid = variant => variant && variant.id && Number.isFinite(variant.price) && variant.price > 0;
  const available = variant => valid(variant) && variant.available === true;
  const setText = (selector, text) => { find(selector).textContent = text; };
  function render() {
    const selected = bag(), selectedBottle = bottle(), selectedCombo = combo();
    if (!valid(selected)) return;
    const pink = bagColor === 'Rosa';
    find('[data-single-image]').src = pink ? section.dataset.bagPink : section.dataset.bagBlack;
    find('[data-single-image]').alt = `TakeBag magnética ${pink ? 'rosa' : 'preta'}`;
    section.querySelectorAll('[data-single-color]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.singleColor === bagColor));
      button.disabled = busy || !available(catalog.bags.find(v => v.color === button.dataset.singleColor));
    });
    section.querySelectorAll('[data-bottle-color]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.bottleColor === bottleColor));
      button.disabled = busy || !available(catalog.combos.find(v => v.bag === bagColor && v.bottle === button.dataset.bottleColor));
    });
    setText('[data-single-price]', money(selected.price));
    const saving = Math.max(0, Number(selected.compare || 0) - selected.price);
    find('[data-single-old]').hidden = !saving;
    setText('[data-single-old]', money(selected.compare || 0));
    find('[data-single-saving]').hidden = !saving;
    setText('[data-single-saving]', `Economize ${money(saving)}`);
    fallback.href = `${fallback.pathname}?variant=${selected.id}`;
    buy.disabled = busy || uncertain || !available(selected);
    buy.textContent = uncertain ? 'Confira seu carrinho abaixo' : (available(selected) ? 'Comprar uma TakeBag' : 'Cor indisponível');
    no.disabled = busy || settled || !available(selected);
    no.textContent = `Não, levar só a bag · ${money(selected.price)}`;
    yes.disabled = busy || settled || !available(selectedCombo);
    close.disabled = busy;
    const bottlePink = bottleColor === 'Rosa';
    setText('[data-single-offer-summary]', `Sua seleção: bag ${pink ? 'rosa' : 'preta'} + garrafa ${bottlePink ? 'rosa' : 'preta'}.`);
    find('[data-single-bottle-image]').src = bottlePink ? section.dataset.bottlePink : section.dataset.bottleBlack;
    find('[data-single-bottle-image]').alt = `Garrafa TakeBag ${bottlePink ? 'rosa' : 'preta'}`;
    if (valid(selectedCombo) && valid(selectedBottle)) {
      const separate = reference(selected) + reference(selectedBottle);
      const economy = Math.max(0, separate - selectedCombo.price);
      setText('[data-single-extra]', money(Math.max(0, selectedCombo.price - selected.price)));
      setText('[data-single-combo-price]', money(selectedCombo.price));
      setText('[data-single-separate]', money(separate));
      find('[data-single-separate]').hidden = !economy;
      setText('[data-single-combo-saving]', `Economia total: ${money(economy)}`);
      find('[data-single-combo-saving]').hidden = !economy;
      yes.textContent = `Sim, levar bag + garrafa · ${money(selectedCombo.price)}`;
    } else {
      setText('[data-single-extra]', 'indisponível');
      setText('[data-single-combo-price]', 'Combinação indisponível');
      find('[data-single-separate]').hidden = true;
      find('[data-single-combo-saving]').hidden = true;
      yes.disabled = true;
    }
    if (busy) {
      yes.textContent = 'Adicionando…';
      no.textContent = 'Aguarde…';
    }
  }
  function chooseBag(color, announce = true) {
    if (busy || !catalog.bags.some(v => v.color === color)) return;
    bagColor = color;
    if (!available(combo())) {
      bottleColor = catalog.combos.find(v => v.bag === color && v.available)?.bottle || bottleColor;
    }
    render();
    if (announce) document.dispatchEvent(new CustomEvent('takebag:single-color', {detail: {color}}));
  }
  function openOffer() {
    if (busy || uncertain || !available(bag())) return;
    settled = false;
    message('');
    showCartLink(false);
    render();
    document.documentElement.classList.add('tb-offer-active');
    const sheet = mobile.matches && typeof offer.showModal === 'function';
    offer.hidden = false;
    offer.dataset.sheet = String(sheet);
    if (sheet) {
      offer.showModal();
      document.documentElement.classList.add('tb-offer-open');
    } else {
      // Inline desktop dialog: avoid the browser's automatic scrolling focus step.
      offer.setAttribute('open', '');
      details.inert = true;
      details.setAttribute('aria-hidden', 'true');
      commerce.classList.add('is-offering');
    }
    buy.setAttribute('aria-expanded', 'true');
    find('#tb-single-offer-title').focus({preventScroll: true});
    // Preserve the reading position; the mobile offer opens in the top layer.
  }
  function closeOffer(focus = true) {
    if (busy) return;
    if (offer.open) offer.close();
    document.documentElement.classList.remove('tb-offer-open');
    document.documentElement.classList.remove('tb-offer-active');
    offer.hidden = true;
    details.inert = false;
    details.removeAttribute('aria-hidden');
    commerce.classList.remove('is-offering');
    buy.setAttribute('aria-expanded', 'false');
    if (focus) (buy.disabled && !cartLink.hidden ? cartLink : buy).focus({preventScroll: true});
  }
  async function addSelection(withBottle) {
    if (busy || settled) return;
    if (window.TakebagCartMutation) {
      message('Aguarde a atualização do carrinho e tente novamente.');
      return;
    }
    const selected = withBottle ? combo() : bag();
    if (!available(selected)) { message('Esta cor está indisponível. Escolha outra combinação.'); return; }
    busy = true;
    offer.setAttribute('aria-busy', 'true');
    let releaseMutation;
    const mutation = new Promise(resolve => { releaseMutation = resolve; });
    window.TakebagCartMutation = mutation;
    render();
    message('Adicionando ao carrinho…');
    let added = false, safeToRetry = false;
    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: selected.id, quantity: 1}], sections: ['mini-cart']})
      });
      if (!response.ok) {
        // Only an explicit rejection is safe to retry. A 5xx may follow an accepted mutation.
        safeToRetry = [400, 404, 422, 429].includes(response.status);
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Não foi possível adicionar esta seleção. Tente outra cor.');
      }
      added = true;
      settled = true;
      const result = await response.json().catch(() => ({}));
      const cartResponse = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
      if (!cartResponse.ok) throw new Error('cart-render');
      const cart = await cartResponse.json();
      if (typeof result.sections?.['mini-cart'] === 'string' && result.sections['mini-cart'].includes('<cart-drawer')) cart.sections = result.sections;
      else delete cart.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {bubbles: true, detail: {cart}}));
      const drawer = document.querySelector('#mini-cart');
      const isDrawer = window.themeVariables?.settings?.cartType === 'drawer';
      if (drawer && isDrawer) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true, detail: {cart, openMiniCart: true}}));
      } else window.location.assign(`${root}cart`);
      message(withBottle ? 'Bag e garrafa adicionadas ao carrinho.' : 'Sua bag foi adicionada ao carrinho.');
      showCartLink(true);
    } catch (error) {
      if (added) {
        message('Adicionado. Abra o carrinho para conferir sua seleção.');
        showCartLink(true);
      } else if (safeToRetry) message(error.message);
      else {
        settled = true;
        uncertain = true;
        message('Não foi possível confirmar a atualização. Abra o carrinho para conferir sua seleção antes de continuar.');
        showCartLink(true);
      }
    } finally {
      busy = false;
      offer.removeAttribute('aria-busy');
      if (window.TakebagCartMutation === mutation) window.TakebagCartMutation = null;
      releaseMutation();
      render();
      if (added) closeOffer(false);
    }
  }
  section.querySelectorAll('[data-single-color]').forEach(button => button.addEventListener('click', () => chooseBag(button.dataset.singleColor)));
  section.querySelectorAll('[data-bottle-color]').forEach(button => button.addEventListener('click', () => { if (busy) return; bottleColor = button.dataset.bottleColor; render(); }));
  document.addEventListener('takebag:journey-color', event => chooseBag(event.detail?.color, false));
  buy.addEventListener('click', openOffer);
  close.addEventListener('click', () => closeOffer());
  offer.addEventListener('cancel', event => { event.preventDefault(); closeOffer(); });
  offer.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); closeOffer(); } });
  yes.addEventListener('click', () => addSelection(true));
  no.addEventListener('click', () => addSelection(false));
  fallback.hidden = true;
  buy.hidden = false;
  find('[data-single-colors]').hidden = false;
  render();
})();
